/* eslint-disable  */
//@ts-nocheck
import React from 'react';
import VideoPlayer from 'react-hls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';

import { formatFileSizeInBytes, formatDuration } from './mux';
import * as enums from '@playbook-technologies/common-enums';
import { faFileArrowDown } from '@fortawesome/pro-regular-svg-icons';

const ReactHlsPlayer = React.memo(function ReactHlsPlayer(props) {
  return <VideoPlayer url={props.video} poster={props.thumbnail} />;
});

class VideoPlayerWithPoster extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { video, thumbnail, clicked, onClick } = this.props;
    return (
      <div
        style={{
          width: '300px',
          height: '235px',
          gridArea: 'video',
          position: 'relative',
        }}
      >
        {clicked ? (
          <ReactHlsPlayer video={video} thumbnail={thumbnail} />
        ) : (
          <img
            src={thumbnail}
            loading="lazy"
            style={{ height: '100%', width: '100%', borderRadius: '5px' }}
          />
        )}
        <FontAwesomeIcon
          onClick={onClick}
          icon={faPlay}
          style={{
            display: clicked ? 'none' : 'inline-block',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: '#fff',
            fontSize: '2rem',
            cursor: 'pointer',
          }}
        />
      </div>
    );
  }
}

function downloadURI(uri, name) {
  var link = document.createElement('a');
  link.style.display = 'none';
  link.href = uri;
  link.download = name + '.mp4';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

class VideoItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clicked: false,
      deleteInProgress: false,
    };
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.setState({
      clicked: true,
    });
  }

  render() {
    if (!this.props.video || !this.props.video.status) {
      return null;
    }
    const { video } = this.props;

    const downloadLink = video?.downloadLink || {};
    const download =
      downloadLink.high || downloadLink.medium || downloadLink.low;
    const downloadURL = download?.link;

    return (
      <div className="relative">
        <div className="video-library-list-item">
          <div className="relative">
            <RenderVideoContent
              video={video}
              deleteInProgress={this.state.deleteInProgress}
              setDeleteInProgress={() =>
                this.setState({
                  deleteInProgress: !this.state.deleteInProgress,
                })
              }
              removeVideoFromLibrary={this.props.removeVideoFromLibrary}
              clicked={this.state.clicked}
              onClick={this.onClick}
            />
            {downloadURL && (
              <a
                onClick={() => downloadURI(downloadURL, video.title)}
                className="absolute bottom-4 right-4 text-3xl cursor-pointer"
              >
                <FontAwesomeIcon
                  icon={faFileArrowDown}
                  className="text-primary"
                />
              </a>
            )}
          </div>
          <div className="video-info">
            <span className="video-info-created">
              {Intl.DateTimeFormat('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              }).format(new Date(video.createdAt))}
            </span>
            <div>
              <span className="video-info-size">
                {formatFileSizeInBytes(video.fileSize)}
              </span>
              {video.duration ? (
                <span className="video-info-duration">
                  {formatDuration(video.duration)}
                </span>
              ) : null}
            </div>
            {video.title ? (
              <span className="video-title">{video.title}</span>
            ) : null}
          </div>
        </div>
        {video.status === enums.MuxVideoStatus.PROCESSING.FINISHED ? (
          <svg
            onClick={() =>
              this.setState({ deleteInProgress: !this.state.deleteInProgress })
            }
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              position: 'absolute',
              top: '5px',
              right: '10px',
              cursor: 'pointer',
            }}
          >
            <circle cx="12" cy="12" r="12" fill="#6367ef" />
            <path
              d="M15.6251 8.34483C15.2871 8.00688 14.7396 8.00688 14.4017 8.34483L11.9852 10.7613L9.56866 8.34483C9.23071 8.00688 8.68321 8.00688 8.34526 8.34483C8.00731 8.68278 8.00731 9.23028 8.34526 9.56823L10.7618 11.9847L8.34526 14.4013C8.00731 14.7392 8.00731 15.2867 8.34526 15.6247C8.51432 15.7937 8.73564 15.8782 8.95696 15.8782C9.17828 15.8782 9.39977 15.7937 9.56866 15.6247L11.9852 13.2081L14.4017 15.6247C14.5707 15.7937 14.7921 15.8782 15.0134 15.8782C15.2347 15.8782 15.4562 15.7937 15.6251 15.6247C15.963 15.2867 15.963 14.7392 15.6251 14.4013L13.2086 11.9847L15.6251 9.56823C15.963 9.23028 15.963 8.68278 15.6251 8.34483Z"
              fill="white"
            />
          </svg>
        ) : null}
      </div>
    );
  }
}

export default VideoItem;

const RenderVideoContent = ({
  video,
  deleteInProgress,
  removeVideoFromLibrary,
  clicked,
  onClick,
  setDeleteInProgress,
}) => {
  if (deleteInProgress) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '235px',
          borderRadius: '5px',
          flexDirection: 'column',
          color: '#fff',
          backgroundColor: '#000',
          fontWeight: 600,
        }}
      >
        <p>Are you sure to remove this video?</p>
        <span
          onClick={() => removeVideoFromLibrary(video.id)}
          style={{
            color: '#6367ef',
            cursor: 'pointer',
            fontWeight: 600,
            padding: '10px',
          }}
        >
          YES, REMOVE
        </span>
        <span
          onClick={() => setDeleteInProgress()}
          style={{ cursor: 'pointer', fontWeight: 600 }}
        >
          CANCEL
        </span>
      </div>
    );
  }

  switch (video.status) {
    case enums.MuxVideoStatus.UPLOAD.STARTED: // TODO KP ensure this in npm package
    case enums.MuxVideoStatus.UPLOAD.FINISHED:
    case enums.MuxVideoStatus.PROCESSING.ENCODE_FINISHED:
    case enums.MuxVideoStatus.PROCESSING.STARTED: {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            height: '235px',
            borderRadius: '5px',
            backgroundColor: '#D5D7D8',
          }}
        >
          <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.08274 12.7489V24.0813L15.7421 19.7552C14.7463 21.4409 14.1655 23.4 14.1655 25.5007C14.1655 27.566 14.7264 29.4968 15.6925 31.1641H2.8331C1.27064 31.1641 0 29.8934 0 28.331V2.8331C0 1.27206 1.27064 0 2.8331 0H19.0016L25.4979 6.49629V14.1683C22.2115 14.1683 19.2622 15.5735 17.1927 17.8074L7.08274 12.7489ZM24.0813 8.49929L16.9986 1.41655V8.49929H24.0813Z"
              fill="#9B9B9B"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M34 24.0841V26.9172H32.4389C32.2548 27.8181 31.895 28.6553 31.402 29.399L32.5126 30.5053L30.511 32.5111L29.4004 31.4006C28.6567 31.8935 27.8196 32.2533 26.9172 32.4389V33.9999H24.0841V32.4389C23.1818 32.2562 22.3432 31.8949 21.5995 31.402L20.4917 32.514L18.4873 30.5124L19.5965 29.4004C19.1049 28.6553 18.7451 27.8209 18.5596 26.9172H16.9985V24.0841H18.5596C18.7437 23.1832 19.1035 22.3431 19.5965 21.5995L18.4873 20.4903L20.4903 18.4873L21.5995 19.5965C22.3432 19.1049 23.1789 18.7437 24.0827 18.561V17.0013H26.9158V18.561C27.8181 18.7437 28.6539 19.1035 29.3962 19.5965L30.5082 18.4845L32.5112 20.4875L31.4006 21.5995C31.8935 22.3403 32.2533 23.1789 32.4389 24.0841H34ZM22.6648 25.5006C22.6648 27.0631 23.9326 28.3337 25.4979 28.3337C27.0617 28.3337 28.331 27.0631 28.331 25.5006C28.331 23.9354 27.0617 22.6675 25.4979 22.6675C23.9326 22.6675 22.6648 23.9354 22.6648 25.5006Z"
              fill="#9B9B9B"
            />
          </svg>
          <span style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            Processing
          </span>
          <span style={{ fontSize: '0.9rem' }}>
            Please refresh page in a few minutes
          </span>
        </div>
      );
    }
    case enums.MuxVideoStatus.PROCESSING.FINISHED: {
      return (
        <VideoPlayerWithPoster
          video={video.video || video.videoUrl}
          thumbnail={video.thumbnail || video.videoThumbnailUrl}
          clicked={clicked}
          onClick={onClick}
        />
      );
    }
    default:
      return null;
  }
};
